import React, { memo } from 'react';

import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import { formatMoney } from '@src/helpers/formatMoney';

import { formatFullDealOfferTerm } from '../../lib';

import styles from './FullDealOffer.module.scss';

type Props = {
  amount: number;
  term: number;
};

export const FullDealOffer = memo(({ amount, term }: Props) => {
  const formatedTerm = formatFullDealOfferTerm(term);
  return (
    <Card className={styles.container} size={16}>
      <Space justify="space-between">
        <Text size={14}>Сумма</Text>

        <Text size={14} strong>
          {formatMoney(amount)}
        </Text>
      </Space>

      <Space justify="space-between">
        <Text size={14}>Срок</Text>
        <Text size={14} strong>
          {formatedTerm.displayedTerm} {formatedTerm.postfix}
        </Text>
      </Space>
    </Card>
  );
});

FullDealOffer.displayName = 'FullDealOffer';
